import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToasterService, Toast } from './toaster.service';
import { ToasterComponent } from './toaster.component';

@Component({
  selector: 'app-toaster-stack',
  standalone: true,
  imports: [CommonModule, ToasterComponent],
  template: `
    <div class="toaster-stack">
      <ng-container *ngFor="let toast of toasts">
        <app-toaster
          [mainTitle]="toast.mainTitle"
          [subTitle]="toast.subTitle"
          [color]="toast.color"
          [status]="toast.status"
          [view]="toast.view ?? null"
          (close)="onClose(toast.id)"
          (viewClick)="onView(toast)"
        ></app-toaster>
      </ng-container>
    </div>
  `,
  styleUrls: ['./toaster.component.scss']
})
export class ToasterStackComponent {
  toasts: Toast[] = [];

  constructor(private readonly toaster: ToasterService) {
    this.toaster.toasts$.subscribe(toasts => {
      this.toasts = toasts;
    });
  }

  onClose(id: string) {
    this.toaster.dismissToast(id);
  }

  onView(toast: Toast) {
    if (toast.view) {
      window.location.href = toast.view;
    }
  }
} 